export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  let errorMsg = null;

  if (!rules) {
    return { isValid: isValid, errorMsg: errorMsg };  //eslint-disable-line
  }

  if (rules.required) {
    isValid = value.trim() !== '' && isValid;
    errorMsg = 'Missing';
  }

  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
    errorMsg = `Minimum no. of characters should be ${rules.minLength}`;
  }

  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
    errorMsg = `No. of characters should not exceed ${rules.maxLength}`;
  }

  if (rules.isEmail) {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
    errorMsg = 'Email format incorrect';
  }

  if (rules.isNumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
    errorMsg = 'Enter only numeric value';
  }

  if (rules.isValueRequired) {
    isValid = value !== null;
    errorMsg = 'Missing';
  }

  if (rules.noSpacesAllowed) {
    const arr = value.trim().split(' ');
    if (arr.length > 1) {
      isValid = false;
      errorMsg = 'Enter only one word';
    }
  }

  return { isValid: isValid, errorMsg: errorMsg };  //eslint-disable-line
};


export const changeInputHandler = (event, inputs, field) => {
  let value = null;
  let file = null;
  try {
    event.persist();
    if (event.target.files) {
      value = event.target.value;  // eslint-disable-line
      file = event.target.files[0]; // eslint-disable-line
    } else {
      value = event.target.value;  // eslint-disable-line
    }
  } catch (error) {
    value = event;
  }
  const validity = checkValidity(value, inputs[field].validation);
  return {
    [field]: updateObject(inputs[field], {
      value: value, // eslint-disable-line
      valid: validity.isValid,
      errorMsg: validity.errorMsg,
      touched: true,
      file: file,  // eslint-disable-line
    }),
  };
};


export const handleFormSubmit = (event, inputs) => {
  event.preventDefault();

  const result = {
    fields: {},
    formError: false,
    inputs: null,
  };

  for (const key in inputs) {
    if (!inputs[key].valid) {
      const updatedInput = updateObject(
        inputs, {
          [key]: updateObject(inputs[key], {
            touched: true,
          }),
        },
      );
      result.formError = true;
      result.inputs = updatedInput;
      break;
    }
    if (inputs[key].file) {
      result.fields[key] = inputs[key].file;
    } else {
      result.fields[key] = inputs[key].value;
    }
  }

  return result;
};


export const updateFieldErrorsHandler = (inputs, errorData) => {
  Object.keys(errorData).map((key) => {
    const input = inputs[key];
    if (input) {
      input.valid = false;
      input.touched = true;
      input.errorMsg = errorData[key][0];  // eslint-disable-line
      inputs[key] = input;  // eslint-disable-line
    }
    return null;
  });
  return inputs;
};



// WEBPACK FOOTER //
// ./src/common/utility.js